import { APP_FEASIBILITY } from "./Constant";
import { AllowedAppNames } from "./Types";

/**
 * To set the application key in session storage
 * @param appKey app key to set
 */
export const setAppKey = (appKey: AllowedAppNames): void => {
  sessionStorage.setItem("appKey", appKey);
  sessionStorage.removeItem("artefactsList");
};

/**
 * To get the application key from session storage
 * @returns the app key
 */
export const getAppKey = (): AllowedAppNames => {
  if (sessionStorage.getItem("appKey")) {
    return sessionStorage.getItem("appKey") as AllowedAppNames;
  }
  return APP_FEASIBILITY;
};
